export enum UserActionTypes {
  UPDATE_USER = "@@user/UPDATE_USER"
}
